import { gql } from "apollo-boost";


export const CREATE_UNIT = gql`
mutation CreateUnit($data: UnitInput) {
    createUnit(data: $data) {
      id
    }
  }
`

export const DELETE_UNIT = gql`
mutation DeleteUnit($where: UnitWhereInputOne!) {
    deleteUnit(where: $where) {
      name
      id
    }
  }
`

export const UPDATE_UNIT = gql`
mutation UpdateUnit($where: UnitWhereInputOne!, $data: UnitInput) {
  updateUnit(where: $where, data: $data) {
    id
  }
}
`

export const CREATE_SURVIVAL = gql`
mutation CreateSurvival($data: SurvivalInput) {
  createSurvival(data: $data) {
    message
  }
}
`

export const UPDATE_SURVIVAL = gql`
mutation UpdateSurvival($data: SurvivalInput, $where: SurvivalWhereInputOne!) {
  updateSurvival(data: $data, where: $where) {
    message
  }
}
`
export const DELETED_SURVIVAL = gql`
mutation DeleteSurvival($where: SurvivalWhereInputOne!) {
  deleteSurvival(where: $where) {
    message
  }
}
`